import { createEntityAdapter, EntityState } from '@ngrx/entity';

import { SortOrder } from '@common/utils/search-sort';

export interface BuildingItem {
  id: number;
  lat: number;
  lng: number;
  name: string;
  address: string;
  rooms: RoomItem[];
}

export type BuildingsList = BuildingItem[];

export interface RoomItem {
  building: number;
  id: number;
  name: string;
  schema: string;
  devices: RoomItemDevice[];
  devicesPositions: RoomItemDevicePosition[];
}

export interface RoomItemDevice {
  deviceModelId: number;
  id: number;
  // TODO: add type
  lastData: any;
  name: string;
  uniqueId: string;
}

export interface RoomItemDevicePosition {
  deviceId: number | null;
  x: number;
  y: number;
}

export interface LastPageStateBuildings {
  searchValue: string;
  sortOrder: SortOrder;
  openedBuildingIds: number[];
  openedRoomId: number | null;
}

export interface BuildingsState extends EntityState<BuildingItem> {
  lastPageState: LastPageStateBuildings;
  loading: boolean;
  error?: string;
}

export const buildingsAdapter = createEntityAdapter<BuildingItem>({
  selectId: (item) => item.id as number,
});

export const initialStateBuildings: BuildingsState = buildingsAdapter.getInitialState({
  lastPageState: {
    searchValue: '',
    sortOrder: SortOrder.Asc,
    openedBuildingIds: [],
    openedRoomId: null,
  },
  loading: false,
  error: undefined,
});
